import { render, staticRenderFns } from "./freebie-offer.vue?vue&type=template&id=b2d125f6&scoped=true&"
import script from "./freebie-offer.vue?vue&type=script&lang=js&"
export * from "./freebie-offer.vue?vue&type=script&lang=js&"
import style0 from "./freebie-offer.vue?vue&type=style&index=0&id=b2d125f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d125f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
